import { API_BASE_URL } from './client';
import { consumeChatNdjsonStream } from './streamNdjson';

export const listModules = async (keycloak) => {
  const response = await fetch(`${API_BASE_URL}/modules/`, {
    headers: { Authorization: `Bearer ${keycloak.token}` },
  });
  if (!response.ok) throw new Error('Failed to list modules');
  return response.json();
};

export const getAssistantModules = async (keycloak, assistantId) => {
  const response = await fetch(`${API_BASE_URL}/assistants/${assistantId}/modules`, {
    headers: { Authorization: `Bearer ${keycloak.token}` },
  });
  if (!response.ok) throw new Error('Failed to load assistant modules');
  return response.json();
};

export const updateAssistantModules = async (keycloak, assistantId, modules) => {
  const response = await fetch(`${API_BASE_URL}/assistants/${assistantId}/modules`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ modules }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Failed to update modules');
  }
  return response.json();
};

async function moduleStreamRequest(url, keycloak, body, streamOpts) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Module request failed');
  }
  await consumeChatNdjsonStream(response, streamOpts);
}

export const startModuleStream = async (keycloak, assistantId, moduleId, sessionId, streamOpts) => {
  await moduleStreamRequest(
    `${API_BASE_URL}/assistants/${assistantId}/modules/${moduleId}/start`,
    keycloak,
    { session_id: sessionId },
    streamOpts,
  );
};

export const moduleTurnStream = async (
  keycloak,
  assistantId,
  moduleId,
  { sessionId, userText, actionId, moduleSessionId },
  streamOpts,
) => {
  await moduleStreamRequest(
    `${API_BASE_URL}/assistants/${assistantId}/modules/${moduleId}/turn`,
    keycloak,
    {
      session_id: sessionId,
      user_text: userText || undefined,
      action_id: actionId || undefined,
      module_session_id: moduleSessionId || undefined,
    },
    streamOpts,
  );
};
